import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { HomeSearchKeywordList } from '@/types/search';

const { persistAtom } = recoilPersist();

export const recentHomeSearchKeywordListState = atom<HomeSearchKeywordList>({
  key: 'recentHomeSearchKeywordListState',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

// button을 보지 않기를 원하는 경우
export const isPreventStickyButtonOpenState = atom<boolean>({
  key: 'isPreventStickyButtonOpenState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
